import api from "./api";

export interface FeatureEstimateRequest {
  pid: number;
  featureCode: string;
  event: string;
  count: number,
}

/** 获取扣除预估 */
export const featureEstimate = async (params: FeatureEstimateRequest): Promise<number> => {
  const res = await api.post<number>('/feature/estimate', {
    pid: params.pid,
    event: params.event,
    count: params.count,
    feature_code: params.featureCode,
  });
  return res.data;
}